TS.ns('WL');

WL.financialProductEditModel = new Class({
    Extends: TS.domain.EditDomain,

    _beforeConvert: function (json) {
        var me = this;

        me.parent();
    },

    _afterConvert: function () {
        var me = this,
            detailList = me.getDomainProperty('viewRenderProductDetails_gridProductDetails_Property');
        me.parent();
        
        if (detailList != null) {
            detailList.fields.viewRenderProductDetails_Details1_Field.renderer = "hyperlinkGrid";

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }
    },

    _hookProperties: function () {
        var me = this,
            detailList = me.getDomainProperty('viewRenderProductDetails_gridProductDetails_Property'),
            cat;

        me.parent();
        
        cat = detailList.commands;

        newCmd = new TS.viewModel.Command();
        newCmd['Code'] = 'AddAction';
        newCmd['Text'] = me.AddActionCommandText;
        newCmd['handler'] = '_addDetail';
        newCmd['IconCode'] = 'plus';

        cat.push(newCmd);

        detailList.on('cellBeginEdit', me._onDetailBeginEdit);

        propertyList = me.getDomainProperty('PropertyList');

        if (propertyList) {
            propertyList.on('addNew', me._onPropertyAdded);
            propertyList.on('cellValueChanged', me._onPropertyChanged, me);
        }
    },

    _onDetailBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'Details') {
            e.preventDefault();
            owner._editDetail();
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

    _addDetail: function () {
        var me = this,
            vm,
            url = '../financialproductdetail/Edit?';

        me.performServerCommand({
            cmd: 'Dummy',
            submitModel: true,
            blockUI: true
        });

        params = {
            popup: true,
            newAction: true
        }
        url += $.param(params);

        TS.UI.showDomain({
            url: url,
            viewModel: vm,
            popupWidth: window.innerWidth * 8 / 10,
            popupHeight: window.innerHeight * 9 / 10
        });
    },

    _editDetail: function () {
        var me = this,
            vm,
            url = '../financialproductdetail/Edit?';

        me.performServerCommand('Dummy', true, null, null, false, true);

        var detailList = me.getDomainProperty('viewRenderProductDetails_gridProductDetails_Property');
        if (detailList.selectedItem() == null) return;

        params = {
            popup: true,
            UID: detailList.selectedItem().UID()
        }
        url += $.param(params);

        TS.UI.showDomain({
            url: url,
            viewModel: vm,
            popupWidth: window.innerWidth * 8 / 10,
            popupHeight: window.innerHeight * 9 / 10
        });
    },

    _onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    _onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        });
    }
});